import type { ProjectionItem } from "../types";

export function ProjectionField({
  value,
  onChange,
}: {
  value: ProjectionItem[];
  onChange: (v: ProjectionItem[]) => void;
}) {
  function update(idx: number, next: ProjectionItem) {
    onChange(value.map((r, i) => (i === idx ? next : r)));
  }
  function remove(idx: number) {
    onChange(value.filter((_, i) => i !== idx));
  }
  function add() {
    onChange([...value, { label: "New product", balance: 0 }]);
  }

  return (
    <div className="space-y-2">
      {value.map((r, i) => (
        <div key={i} className="grid grid-cols-[1fr_7rem_auto] gap-2 items-center">
          <input
            value={r.label}
            onChange={(e) => update(i, { ...r, label: e.target.value })}
            className="rounded border px-2 py-1.5 text-sm"
          />
          <input
            type="number"
            step="0.01"
            value={r.balance}
            onChange={(e) => update(i, { ...r, balance: parseFloat(e.target.value) || 0 })}
            className="rounded border px-2 py-1.5 text-sm text-right"
            title="Balance £"
          />
          <button
            type="button"
            onClick={() => remove(i)}
            className="text-xs text-neutral-500 hover:text-red-600 px-2"
          >
            ✕
          </button>
        </div>
      ))}
      <button
        type="button"
        onClick={add}
        className="text-sm text-neutral-700 hover:text-neutral-900 underline"
      >
        + Add projection
      </button>
    </div>
  );
}
